import { Component, OnInit, ViewChild, Output, EventEmitter, Input, NgZone, HostListener, inject } from '@angular/core';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { combineLatest, Subscription, zip } from 'rxjs';
import { CampaignService } from 'src/app/services/campaign.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
import { ReportModalComponent } from '../report-modal/report-modal.component';
import { ModalService } from 'src/app/services/modal.service';
import { MatDialog } from '@angular/material/dialog';
import { ScreenService } from 'src/app/services/screen.service';
import { SendEmailDialogComponent } from '../send-email-dialog/send-email-dialog.component';
// import * as $ from 'jquery';
import { Storage } from 'src/app/utils/storage.class';
import { TypeNotesService } from 'src/app/services/type-notes.service';
import { TypeNote } from 'src/app/models/type-note.model';
import { TiersService } from 'src/app/services/tiers.service';
import { Tier } from 'src/app/models/tier.model';
import { Platform } from 'src/app/models/platform';

declare const $: any;
declare const moment: any;

@Component({
  selector: 'app-filter-form',
  templateUrl: './filter-form.component.html',
  styleUrls: ['./filter-form.component.css']
})
export class FilterFormComponent implements OnInit {

  ylabel = [
    { name: 'Campañas', type: 1, disable: 10, arr: 'campaign', id: 'idCampaign', param: 'campaigns' },
    { name: 'Voceros', type: 2, disable: 10, arr: 'spokesman', id: 'idVocero', param: 'voceros' },
    { name: 'Plan de Medios', type: 3, disable: 10, arr: 'plans', id: 'idPlanMedio', param: 'planmedios' },
    { name: 'Plataformas', type: 4, disable: 1, arr: 'platform', id: 'idPlataforma', param: 'plataformas' },
    { name: 'Tipo de Notas', type: 5, disable: 2, arr: 'note', id: 'tipoNota', param: 'tipoNotas' },
    { name: 'Tier', type: 6, disable: 3, arr: 'tiers', id: 'tipoTier', param: 'tipoTiers' }
  ]

  xlabel = [
    { name: 'Ninguno', type: 0, disable: 0, arr: 'ninguno', id: 'ninguno', param: 'ninguno' },
    { name: 'Plataformas', type: 1, disable: 4, arr: 'platform', id: 'idPlataforma', param: 'plataformas' },
    { name: 'Tipo de Notas', type: 2, disable: 5, arr: 'note', id: 'tipoNota', param: 'tipoNotas' },
    { name: 'Tier', type: 3, disable: 6, arr: 'tiers', id: 'tipoTier', param: 'tipoTiers' }
  ]

  selects = [
    { id: 1, select: 'campaign',  form: 'campaign',  all: 'allCampaign'  },
    { id: 2, select: 'spokesman', form: 'spokesman', all: 'allSpokesmen' },
    { id: 3, select: 'plan',      form: 'plans',     all: 'allPlans'     },
    { id: 4, select: 'platform',  form: 'platform',  all: 'allPlatforms' },
    { id: 5, select: 'note',      form: 'note',      all: 'allNotes'     },
    { id: 6, select: 'tier',      form: 'tiers',     all: 'allTiers'     }
  ]

  filterForm = this.formBuilder.group({
    customer: [null, Validators.required],
    xlabel:   [0, Validators.required],
    ylabel:   [null, Validators.required],

    campaign:  [[]],
    spokesman: [[]],
    plans:     [[]],
    platform:  [[]],
    note:      [[]],
    tiers:     [[]],

    from: [null, [Validators.required]],
    to:   [null],

    allSpokesmen: [{ value: false, disabled: false }],
    allCampaign:  [{ value: false, disabled: false }],
    allPlans:     [{ value: false, disabled: false }],
    allPlatforms: [{ value: false, disabled: false }],

    allNotes: [false],
    allTiers: [false],
    isVal:    [false],
    isDet:    [false],
    sol:      [true],
    dolar:    [false]
  });

  user: any;

  @Output() submittedForm = new EventEmitter<any>();
  @Output() spinner = new EventEmitter<boolean>();
  @Input()  selectAll: boolean;

  formSubmitAttempt: boolean = false;
  btn: boolean  = false;
  customers: any[] = [];
  platforms: Platform[] = [];

  notes: TypeNote[] = [];
  tiers: Tier[] = [];

  spokesmen: any[] = [];
  plansMedio: any[] = [];
  customersTwo: any[] = [];
  platformsTwo: any[] = [];
  notesTwo: any[] = [];
  spokesmenTwo: any[] = [];
  campaignSelect: any[] = [];
  results: any[] = [];
  data: any;
  customer: string = '';

  subscriptionCustomers: Subscription;
  subscriptionPlatforms: Subscription;
  subscriptionNotes: Subscription;
  subscriptionCampaign: Subscription;
  subscriptionResults: Subscription;

  loadF = false

  x: number = 1
  y: number = 1

  @HostListener('window:resize', ['$event'])
  onResize($event: Event): void {
    this.heightScreen = window.innerHeight;
    this.screenService.updateHeightScreen(window.innerHeight);
  }

  heightScreen: number = window.innerHeight;

  constructor(
    private modalService: ModalService,
    private campaignService: CampaignService,
    public userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private ngZone: NgZone,
    private screenService: ScreenService,
    private storage: Storage,
    private typeNotesService: TypeNotesService,
    private tiersService: TiersService
  ) {
    this.handleYLabelChange();
    this.handleXLabelChange();
  }

  ngOnInit() {
    this.getTiersAndTypeNotes();

    this.user = this.userService.user.value;
    // Obtener todos los cliente_id del usuario
    const clienteIds = this.user.tenants_user.map(tu => tu.cliente_id);
    console.log('Cliente IDs disponibles:', clienteIds);
    
    if (this.campaignService.filter.idCliente) {
      this.loadF = true
    }

    $(document).ready(() => {
      $('#customer').select2({
        width: '100%',
        placeholder: 'Seleccione',
        allowClear: true
      });

      $('#customer').on('select2:select', (e) => {
        let id = Number(e.params.data.id);
        this.customerChange(id);
      });

      $('#customer').on('select2:clear', (e) => {
        this.customerChange(null);
      });

      $('#ylabel').select2({
        width: '100%',
        placeholder: 'Seleccione',
        allowClear: false
      });

      $('#ylabel').on('select2:select', (e) => {
        this.filterForm.get('ylabel').setValue(Number(e.params.data.id))
        this.activeView(Number(e.params.data.id))
      });

      $('#xlabel').select2({
        width: '100%',
        placeholder: 'Seleccione',
        allowClear: false
      });

      $('#xlabel').val('0');
      $('#xlabel').trigger('change.select2');
      this.filterForm.get('xlabel').setValue(0);

      $('#xlabel').on('select2:select', (e) => {
        this.filterForm.get('xlabel').setValue(Number(e.params.data.id))
        this.activeView(Number(e.params.data.id) + 3)
      });
    });

    $('input[name="daterange"]').daterangepicker({
      locale: {
        format: 'DD/MM/YYYY',
        "daysOfWeek": [ "Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa" ],
        "monthNames": [
            "Enero",  "Febrero",  "Marzo",      "Abril",   "Mayo",      "Junio",
            "Julio",  "Agosto",   "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ]
      },
      autoApply: true,
      autoUpdateInput: false,
      linkedCalendars: false,
      showDropdowns: true
    });

    $('input[name="daterange"]').on('apply.daterangepicker', (e, picker) => {
      let startDate = picker.startDate.format('YYYY-MM-DD');
      let endDate = picker.endDate.format('YYYY-MM-DD');
      $('input[name="daterange"]').val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
      this.filterForm.get('from').setValue(startDate);
      this.filterForm.get('to').setValue(endDate);
    });

    // Si el usuario tiene clientes asignados, usar el primero
    if (this.user.tenants_user.length > 0 && this.user.tenants_user[0].cliente_id > 0) {
      this.customerChange(this.user.tenants_user[0].cliente_id);
    }


    this.subscriptionPlatforms = this.campaignService.getPlatforms().subscribe(response => {
      this.platforms = response;
      this.filterForm.get('allPlatforms').enable();
    });

    this.subscriptionCustomers = this.campaignService.getCustomers().subscribe(response => {
      // Obtener los cliente_ids del usuario
       const userClienteIds = this.user.tenants_user.map(tu => tu.cliente_id).filter(id => id > 0);
      
      if (userClienteIds.length > 0) {
        this.customers = response.filter(c => userClienteIds.includes(c.id));
      
        if (this.customers.length > 0) {
          this.customer = this.customers[0].nombreComercial;
        }
      } else {
        this.customers = response;
      }
      
      this.customers = this.customers.reverse()
      if (this.campaignService.filter.idCliente) {
        this.customerChange(this.campaignService.filter.idCliente)
      }
    });
  }

  private getTiersAndTypeNotes(): void {
    zip(
      this.tiersService.getAll(),
      this.typeNotesService.getAll()
    ).subscribe(([ { data: tiers }, { data: typeNotes } ]) => {
      this.tiers = tiers;
      this.notes = typeNotes;
    });
  }

  private handleYLabelChange() {
    this.filterForm.get('ylabel').valueChanges.subscribe(ylabel => {
      const xlabelCtrl = this.filterForm.get('xlabel').value;
      const xlabel = xlabelCtrl === 1 ? 4 : xlabelCtrl === 2 ? 5 : xlabelCtrl === 3 ? 6 : null;
      const array = [
        { id: 1, select: '#campaign', form: 'campaign', all: 'allCampaign', arr: this.campaignSelect },
        { id: 2, select: '#spokesman', form: 'spokesman', all: 'allSpokesmen', arr: this.spokesmen },
        { id: 3, select: '#plan', form: 'plans', all: 'allPlans', arr: this.plansMedio },
        { id: 4, select: '#platform', form: 'platform', all: 'allPlatforms', arr: this.platforms },
        { id: 5, select: '#note', form: 'note', all: 'allNotes', arr: this.notes },
        { id: 6, select: '#tier', form: 'tiers', all: 'allTiers', arr: this.tiers }
      ]
      let selecYLabel = array.find(s => s.id == ylabel);
      let selecXLabel = array.find(s => s.id == xlabel);

      if (!Boolean(selecXLabel)) {
        this.filterForm.get('allCampaign').setValue(false);
        this.filterForm.get('allSpokesmen').setValue(false);
        this.filterForm.get('allPlans').setValue(false);
        this.filterForm.get('allPlatforms').setValue(false);
        this.filterForm.get('allNotes').setValue(false);
        this.filterForm.get('allTiers').setValue(false);
      } else {
        const fieldNames: string[] = array.filter(p => p.id !== selecXLabel.id).map(p => p.all);
        fieldNames.forEach(fieldName => {
          if (selecYLabel && selecYLabel.all !== fieldName) {
            this.filterForm.get(fieldName).setValue(false);
          }
        });
      }
    });
  }

  private handleXLabelChange() {
    this.filterForm.get('xlabel').valueChanges.subscribe(xlabel => {
      const ylabel = this.filterForm.get('ylabel').value;

      const array = [
        { id: 1, select: '#campaign', form: 'campaign', all: 'allCampaign', arr: this.campaignSelect },
        { id: 2, select: '#spokesman', form: 'spokesman', all: 'allSpokesmen', arr: this.spokesmen },
        { id: 3, select: '#plan', form: 'plans', all: 'allPlans', arr: this.plansMedio },
        { id: 4, select: '#platform', form: 'platform', all: 'allPlatforms', arr: this.platforms },
        { id: 5, select: '#note', form: 'note', all: 'allNotes', arr: this.notes },
        { id: 6, select: '#tier', form: 'tiers', all: 'allTiers', arr: this.tiers }
      ]
      let selecYLabel = array.find(s => s.id == ylabel);
      let selecXLabel = array.find(s => s.id == xlabel);

      if (selecXLabel) {
        const fieldNames: string[] = array.filter(p => p.id !== selecXLabel.id).map(p => p.all);
        fieldNames.forEach(fieldName => {
          if (selecYLabel && selecYLabel.all !== fieldName) {
            this.filterForm.get(fieldName).setValue(false);
          }
        });
      }
    });
  }

  activeView(id) {
    let selec = this.selects.find(s => s.id == id);
    let closedAfterUnselect = false;

    $(document).ready(() => {
      if ($(`#${selec.select}`).data('select2')) {
        $(`#${selec.select}`).select2('destroy');
      }

      $(`#${selec.select}`).select2({
        width: '100%',
        placeholder: 'Seleccione',
        allowClear: true,
        templateSelection: (data) => {
          if (data.id === '__all__') {
            const count = this.filterForm.get(selec.form).value?.length || 0;
            return $(`<span>Seleccionado todo (${count})</span>`);
          }
          return data.text;
        },
        templateResult: (data) => {
          if (data.id === '__all__') return null;
          return data.text;
        }
      });

      // Al abrir: mostrar todos los items marcados en el dropdown
      $(`#${selec.select}`).on('select2:opening', () => {
        closedAfterUnselect = false; // resetear flag al abrir
        if (this.filterForm.get(selec.all).value) {
          const allIds = (this.filterForm.get(selec.form).value as number[]);
          $(`#${selec.select}`).val(allIds.map(String)).trigger('change.select2');
        }
      });

      $(`#${selec.select}`).on('select2:close', () => {
        if (closedAfterUnselect) {
          closedAfterUnselect = false;
          return; 
        }
        if (this.filterForm.get(selec.all).value) {
          $(`#${selec.select}`).val(['__all__']).trigger('change.select2');
        }
      });

      $(`#${selec.select}`).on('select2:select', (e) => {
        if (e.params.data.id === '__all__') return;
        closedAfterUnselect = false;
        let arr = [...(this.filterForm.get(selec.form).value as number[])];
        arr.push(Number(e.params.data.id));
        this.filterForm.get(selec.form).setValue(arr);

        // Si ya están todos seleccionados → activar "Seleccione todo"
        const totalItems = this.getArrForSelec(selec.id);
        if (totalItems.length > 0 && arr.length === totalItems.length) {
          this.filterForm.get(selec.all).setValue(true);
          if (!$(`${selec.select} option[value="__all__"]`).length) {
            $(`${selec.select}`).append(new Option('Seleccionado todo', '__all__', false, false));
          }
          $(`#${selec.select}`).val(['__all__']).trigger('change.select2');
          $(`#${selec.select}`).select2('close');
        }
      });

      $(`#${selec.select}`).on('select2:unselect', (e) => {
        if (e.params.data.id === '__all__') return;
        closedAfterUnselect = true;

        let arr = [...(this.filterForm.get(selec.form).value as number[])];
        arr = arr.filter(c => c !== Number(e.params.data.id));
        this.filterForm.get(selec.form).setValue(arr);

        if (this.filterForm.get(selec.all).value) {
          this.filterForm.get(selec.all).setValue(false);
          $(`${selec.select} option[value="__all__"]`).remove();
        }
        // Mostrar los items restantes inmediatamente
        $(`#${selec.select}`).val(arr.map(String)).trigger('change.select2');
      });
    });
  }

  private getArrForSelec(id: number): any[] {
    switch (id) {
      case 1: return this.campaignSelect;
      case 2: return this.spokesmen;
      case 3: return this.plansMedio;
      case 4: return this.platforms;
      case 5: return this.notes;
      case 6: return this.tiers;
      default: return [];
    }
  }

  filterArr(arr, dis) {
    return arr.filter(ft => ft.disable != this.filterForm.get(dis).value)
  }

  getFilterData() {
    //this.customerChange(this.campaignService.filter.idCliente)
    if (this.campaignService.filter.allCampaigns) {
      this.filterForm.get('allCampaign').setValue(true);
    }
    if (this.campaignService.filter.allSpokesmen) {
      this.filterForm.get('allSpokesmen').setValue(true);
    }
    if (this.campaignService.filter.campaigns.length) {
      this.filterForm.get('campaign').setValue(this.campaignService.filter.campaigns);
      this.customersTwo = this.campaignService.filter.campaigns
      $('#campaign').val(this.campaignService.filter.campaigns);
      $('#campaign').trigger('change');
    }
    if (this.campaignService.filter.spokesman.length) {
      this.filterForm.get('spokesman').setValue(this.campaignService.filter.spokesman);
      this.spokesmenTwo = this.campaignService.filter.spokesman
      $('#spokesman').val(this.campaignService.filter.spokesman);
      $('#spokesman').trigger('change');
    }

    if (this.campaignService.filter.plataformas) {
      this.filterForm.get('allPlatforms').setValue(true)
      //this.allPlatformsChange()
    }
    if (!this.campaignService.filter.plataformas) {
      this.filterForm.get('allNotes').setValue(true);
      //this.allNotesChange()
    }
    this.filterForm.get('isVal').setValue(this.campaignService.filter.isVal);
    this.filterForm.get('isDet').setValue(this.campaignService.filter.isDet);

    this.filterForm.get('from').setValue(this.campaignService.filter.fechaInicio);
    this.filterForm.get('to').setValue(this.campaignService.filter.fechaFin);
    let start = this.campaignService.filter.fechaInicio.split('-')
    let end = this.campaignService.filter.fechaFin.split('-')
    $('input[name="daterange"]').val(`${start[2]}/${start[1]}/${start[0]} - ${end[2]}/${end[1]}/${end[0]}`);
    this.loadF = false
    this.onSubmit()
  }

  ngOnDestroy() {
    this.subscriptionCustomers.unsubscribe();
    this.subscriptionPlatforms.unsubscribe();

    if (this.subscriptionCampaign) {
      this.subscriptionCampaign.unsubscribe();
    }
    if (this.subscriptionResults) {
      this.subscriptionResults.unsubscribe();
    }
  }

  customerChange(value) {
    this.filterForm.get('customer').setValue(value);
    let all = ['allSpokesmen', 'allCampaign', 'allPlatforms']
    all.forEach(al => {
      if (this.filterForm.get(al).enable) {
        this.filterForm.get(al).disable();
      }
    })

    this.subscriptionCampaign = combineLatest(
      this.campaignService.getSpokesmen(value),
      this.campaignService.getCampaignSelect(value),
      this.campaignService.getPlans(value)
    ).subscribe(([voceros, campanias, plans]) => {
      this.spokesmen = voceros;
      this.campaignSelect = campanias;
      this.plansMedio = plans;
      all.forEach(al => {
        this.filterForm.get(al).enable();
      })
      if (this.campaignService.filter.idCliente) {
        setTimeout(() => {
          this.getFilterData()
        });
      }
    })
  }

  allChange(type, show) {
    const array = [
      { id: 1, select: '#campaign',  form: 'campaign',  all: 'allCampaign',  arr: this.campaignSelect },
      { id: 2, select: '#spokesman', form: 'spokesman', all: 'allSpokesmen', arr: this.spokesmen },
      { id: 3, select: '#plan',      form: 'plans',     all: 'allPlans',     arr: this.plansMedio },
      { id: 4, select: '#platform',  form: 'platform',  all: 'allPlatforms', arr: this.platforms },
      { id: 5, select: '#note',      form: 'note',      all: 'allNotes',     arr: this.notes },
      { id: 6, select: '#tier',      form: 'tiers',     all: 'allTiers',     arr: this.tiers }
    ];
    const selec = array.find(s => s.id == type);

    if (this.filterForm.get(selec.all).value) {
      // Guardar todos los IDs reales en el formulario
      const filter = selec.arr.map(p => p.id);
      this.filterForm.get(selec.form).setValue(filter);

      if (!$(`${selec.select} option[value="__all__"]`).length) {
        $(`${selec.select}`).append(new Option('Seleccionado todo', '__all__', false, false));
      }
      $(`${selec.select}`).val(['__all__']).trigger('change.select2');
    } else {
      $(`${selec.select} option[value="__all__"]`).remove();
      this.filterForm.get(selec.form).setValue([]);
      $(`${selec.select}`).val([]).trigger('change.select2');
    }
  }

  changeCurrency(form1, form2) {
    if (this.filterForm.get(form1).value) {
      this.filterForm.get(form2).setValue(false)
    }else{
      this.filterForm.get(form2).setValue(true)
    }
  }

  onSubmit() {
    this.formSubmitAttempt = true;
    if (this.filterForm.invalid) {
      return;
    }
    let reportInfo = this.filterForm.value

    const x = reportInfo.xlabel
    const y = reportInfo.ylabel

    const arrX = this.xlabel.find(lb => lb.type == x)
    const arrY = this.ylabel.find(lb => lb.type == y)

    const isSecondSelectEmpty = !Boolean(reportInfo[arrX.arr]);

    if (reportInfo[arrY.arr].length > 0 && isSecondSelectEmpty) {

    }
    else if (reportInfo[arrY.arr].length === 0 && isSecondSelectEmpty) {
      return;
    }
    else if (reportInfo[arrY.arr].length == 0 || reportInfo[arrX.arr].length == 0) {
      return;
    }

    this.btn = true;
    let saveData = {
      idCliente: reportInfo.customer,
      campaigns:    y == 1 ? reportInfo.campaign : [],
      voceros:      y == 2 ? reportInfo.spokesman : [],
      planmedios:   y == 3 ? reportInfo.plans : [],
      plataformas:  this.getPlataformas(),
      // plataformas:  y == 4 || x == 1 ? reportInfo.platform : [],
      tipoNotas:    y == 5 || x == 2 ? reportInfo.note : [],
      tipoTiers:    y == 6 || x == 3 ? [0].concat(reportInfo.tiers) : [],
      fechaInicio: this.filterForm.get('from').value,
      fechaFin: this.filterForm.get('to').value,
      isDet: reportInfo.isDet ? 1 : 0,
      isVal: reportInfo.isVal ? 1 : 0,
      currency: reportInfo.sol ? 'sol' : 'dolar'
    }
    this.spinner.emit(true);
    this.subscriptionResults = this.campaignService.getAll(saveData).subscribe((response: any) => {
      this.spinner.emit(false);
      this.btn = false;
      if (this.campaignService.filter.idCliente) {
        this.campaignService.filter = {
          idCliente: null,
          allCampaigns: false,
          allSpokesmen: false,
          plataformas: false,
          fechaInicio: '',
          fechaFin: '',
          isDet: false,
          isVal: false,
          campaigns: [],
          spokesman: []
        }
      }
      response['customer'] = this.customers.find(cl => cl.id == reportInfo['customer'])
      let xl = y < 4 ? x || 1 : x
      let arrC = this.xlabel.find(lb => lb.type == xl)

      const responseMapped = response.DPRPs.map(el => {
        el.note = this.notes.find(nt => nt.id === el.tipoNota)?.name
        el.tierName = this.tiers.find(nt => nt.id === el.tipoTier)?.name
        el.valorizar = Number(el.valorizado.toFixed(2))
        return el
      });

      const responseFiltered = responseMapped.filter(rp => {
        if (arrC && arrC.param !== 'ninguno') {
          let xn = response.params[arrC.param].map(dtt => {
            return dtt == 0 ? null : dtt
          })
          return xn.includes(rp[arrC.id]) && response.params[arrY.param].includes(rp[arrY.id])
        } else {
          return response.params[arrY.param].includes(rp[arrY.id])
        }
      });
      response.DPRPs = responseFiltered;
      /**
             * Para los primeros criterios "Campañas", "Voceros" y "Plan de Medios", si no se selecciona un segundo criterio, se escogerá Plataformas automáticamente
             */

      let nullTier = response.DPRPs.filter(dp => dp.tipoTier == null).length > 0
      response.params.xlabel = y < 4 ? x || 1 : x
      response.params.ylabel = y
      // Evalua si los el primer criterio es Tier o si el segundo criterio es Tier
      response.params.tipoTiers = y == 6 || x == 3 ? nullTier ? response.params.tipoTiers : reportInfo.tiers : []
      response.params.platforms = this.platforms.filter(pl => y < 4 && !x ? true : reportInfo['platform'].includes(pl.id))
      response.params.typeNotes = this.notes.filter(nt => y == 5 || x == 2 ? reportInfo['note'].includes(nt.id) : true)
      response.params.tiersData = this.tiers.filter(t => y == 6 || x == 3 ? reportInfo['tiers'].includes(t.id) : true)
      response.valorizadoTotal = Number(response.valorizadoTotal.toFixed(2))


      // response.DPRPs = response.DPRPs.map(el => {
      //   el.note = this.notes.find(nt => nt.id === el.tipoNota)?.descripcion
      //   el.tierName = this.tiers.find(nt => nt.id === el.tipoTier)?.descripcion
      //   el.valorizar = Number(el.valorizado.toFixed(2))
      //   return el
      // })
      // response.params.xlabel = Number(x)
      // response.params.ylabel = Number(y)
      // response.params.platforms = this.platforms.filter(pl => reportInfo['platform'].includes(pl.id))
      // response.valorizadoTotal = Number(response.valorizadoTotal.toFixed(2))

      this.data = response;
      this.x = this.data.params.xlabel
      this.y = this.data.params.ylabel
      this.submittedForm.emit(response);
    }, (error) => {
      this.btn = false;
    });
  }

  isFieldValid(field: string) {
    return this.filterForm.get(field).invalid && this.formSubmitAttempt;
  }

  isValid(field: string) {
    let value = this.filterForm.get(field).value
    return value.length == 0 && this.formSubmitAttempt;
  }

  getPlataformas() {
    let reportInfo = this.filterForm.value
    const x = reportInfo.xlabel
    const y = reportInfo.ylabel
    if (y == 4) {
      return reportInfo.platform
    } else {
      if (!x) {
        if (y == 1 || y == 2 || y == 3) {
          return this.platforms.map(c => c.id)
        } else {
          return []
        }
      } else {
        return x == 1 ? reportInfo.platform : []
      }
    }
  }

  openResultDialog() {
    let data = {
      xlabel: this.data.params.plataformas.length && this.y != 4 ? 1 : this.x || this.y - 3,
      ylabel: this.data.params.campaigns.length ? 1 : this.y,
      type: !this.x ? 2 : 1,
      ...this.data
    }
    const height = this.heightScreen - 100 <= 700 ? 700 : this.heightScreen - 100;

    const dialogRef = this.modalService.openModal(ReportModalComponent, {
      data: {
        heightScreen: height,
        ...data
      },
      width: '1000px',
      height: String(height),
      maxHeight: String(height)
    });
    dialogRef.afterClosed().subscribe(result => {
      result.sendEmailDialog ? this.openSendEmailDialog(result.data) : null;
    });
  }

  openSendEmailDialog(data: any) {
    this.dialog.open(SendEmailDialogComponent, {
      data: {
        data: [],
        customer: this.data.customer,
        idPlan: 0,
        title: 'Envío de reporte',
        type: 'reporte',
        docs: false,
        report: data,
        storage: this.storage
      },
      width: '800px'
    });
  }
}
